class BannerCarousel {
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.banner-carousel__slide'));
    this.dots = Array.from(el.querySelectorAll('.banner-carousel__dot'));
    this.prevBtn = el.querySelector('.banner-carousel__arrow--prev');
    this.nextBtn = el.querySelector('.banner-carousel__arrow--next');
    this.current = 0;
    this.autoplay = el.dataset.autoplay === 'true';
    this.speed = parseInt(el.dataset.speed, 10) || 5000;
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.goTo(parseInt(dot.dataset.dotIndex, 10));
        this.restart();
      });
    });

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.current - 1);
        this.restart();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.current + 1);
        this.restart();
      });
    }

    this.el.addEventListener('mouseenter', () => this.stop());
    this.el.addEventListener('mouseleave', () => this.start());

    // Soporte para el editor de temas de Shopify
    document.addEventListener('shopify:block:select', (event) => {
      const slide = this.slides.find((s) => s.contains(event.target) || s === event.target);
      if (slide) {
        this.stop();
        this.goTo(this.slides.indexOf(slide));
      }
    });
    document.addEventListener('shopify:block:deselect', () => this.start());

    this.start();
  }

  goTo(index) {
    const total = this.slides.length;
    this.current = ((index % total) + total) % total;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.current);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
    });
  }

  start() {
    if (!this.autoplay) return;
    this.stop();
    this.timer = setInterval(() => this.goTo(this.current + 1), this.speed);
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restart() {
    this.stop();
    this.start();
  }
}

function initBannerCarousels() {
  document.querySelectorAll('.banner-carousel').forEach((el) => {
    if (!el.dataset.initialized) {
      el.dataset.initialized = 'true';
      new BannerCarousel(el);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBannerCarousels);
} else {
  initBannerCarousels();
}
